import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import '/public/css/pages/listen.css';
import AdCategoriesContext from 'context/AdCategoriesContext';

const ListenPage = ({ errorCode }) => {
  const context = useContext(AdCategoriesContext);
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    context.setPrimaryCategory('listen');
  });
  return <></>;
};
ListenPage.getInitialProps = async ({ res }) => {
  if (res) {
    res.setHeader('Cache-Control', 'public, max-age=3600');
    const errorCode = res.statusCode > 200 ? res.statusCode : false;
    return { layout: 'listen', errorCode };
  }

  return { layout: 'listen' };
};

ListenPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default ListenPage;
